import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HelpIcon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
const SelectField = ({ name, displayName, style, placeholder, hidden, disabled, required, input, meta, onChangeAction, className, showHelpIcon, helpIconTitle, helpIconText, children, isInline, }) => {
    let validationErrors = null;
    let helpIcon = null;
    const hasSuccess = meta.touched && meta.valid && meta.dirty;
    const hasError = meta.touched && meta.error;
    const isHidden = !!hidden;
    const isDisabled = !!disabled;
    const isRequired = !!required;
    const inputName = name || input.name || '';
    const formGroupClasses = classnames({
        'form-group-select': true,
        'has-success': hasSuccess,
        'has-error': !hasSuccess && hasError,
        'form-group': !isInline,
        'form-group-inline': isInline,
        focused: meta && meta.active,
        active: isHidden,
        disabled: isDisabled,
    }, className || '');
    if (!hasSuccess && hasError) {
        validationErrors = _jsx("span", Object.assign({ className: "validation-text" }, { children: meta.error }));
    }
    if (placeholder === null || placeholder === undefined) {
        placeholder = (name ? name : '') + '...';
    }
    if (showHelpIcon) {
        helpIcon = (_jsx("span", Object.assign({ className: "helpIcon" }, { children: _jsx(HelpIcon, { text: helpIconText, title: helpIconTitle }) })));
    }
    return (_jsxs("div", Object.assign({ className: formGroupClasses, style: style }, { children: [_jsxs("label", Object.assign({ className: "control-label", htmlFor: inputName }, { children: [displayName ? displayName : '', " ", required ? '*' : '', ' ', validationErrors] })), helpIcon, _jsx("select", Object.assign({ value: input.value, onBlur: input.onBlur, onFocus: input.onFocus, onChange: (e) => {
                    if (typeof onChangeAction === 'function') {
                        onChangeAction(e.target.value);
                    }
                    input.onChange(e);
                }, required: isRequired, id: inputName, disabled: isDisabled, className: "form-control" }, { children: children }))] })));
};
SelectField.defaultProps = {
    disabled: false,
    hidden: false,
    required: false,
    showError: false,
    isInline: false,
};
export default SelectField;
